import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core';

type Props = FieldExtensionComponentProps<string>;

/**
 * Scaffolder field extension for API Type - renders as radio buttons (PRIVATE / REGIONAL).
 */
export const ApiTypeCombobox = (props: Props) => {
  const { onChange, schema, formData } = props;
  const title = schema.title;
  const value = String(formData ?? schema.default ?? 'REGIONAL');

  return (
    <FormControl component="fieldset" fullWidth>
      <FormLabel component="legend">{title}</FormLabel>
      <RadioGroup row value={value} onChange={(_, newValue) => onChange(newValue ?? 'REGIONAL')}>
        <FormControlLabel value="PRIVATE" control={<Radio />} label="Private" />
        <FormControlLabel value="REGIONAL" control={<Radio />} label="Regional" />
      </RadioGroup>
    </FormControl>
  );
};
